import React from 'react'
import {useTranslation} from "react-i18next";
import { tokens } from 'locales/tokens';

const ExcelDownAnimation = () => {
    const { t } = useTranslation();
    return (
        <div className="excel-ani-content">
            <div
                className="flex align-items-center p-4 border-round-2xl justify-content-center"
                style={{ width: '200px', height: '200px', background: '#ffffff' }}
            >
                <div className="align-content-center">
                    <div className="flex justify-content-center align-content-center">
                        <img className="" src="/spinner_green.gif" alt={t(tokens.common.excel_download_image)} />
                    </div>
                    <div className="flex justify-content-center align-content-center font-bold text-lg mt-4">Down loading...</div>
                </div>
            </div>
        </div>
    )
}

export default ExcelDownAnimation
